// Illustrative worked-example figures shared by both cashback config forms so the numbers can never
// drift between the V1 and V2 screens: €100 wagered on a typical 96% RTP slot (4% house edge). Kept as
// exact literals so the displayed math stays free of float noise.
export const EXAMPLE_WAGER = 100;
export const EXAMPLE_RTP_PERCENT = 96;
export const EXAMPLE_HOUSE_EDGE = 0.04;

// The example figures are whole euros, so two-decimal fixed formatting keeps the payout as a tidy €X.00.
export function formatEuro(amount: number): string {
  return amount.toFixed(2);
}
